import BookByType from "./book-by-type.page";

export default BookByType;
